import React, { useContext, useEffect } from 'react';
import QuestionBasic, {
  OptionsQuestionBasic
} from 'components/Organisms/QuestionBasic/QuestionBasic';
import { useCreateResponseTask } from 'services/task/mutations';
import { TaskContext } from '../MinimumLiquidity';
import { Task, TaskState } from 'gql/graphql';
import { formatterCurrency } from '@common/utils/formatters/formatter';
import { useGetTaskResponsesByTask } from 'services/task/querys';
import SectionSuccessTask from 'scenes/Private/components/SectionSuccessTask/SectionSuccessTask';
import { canEditTaskInfo } from '@common/utils/functions/mains';

interface Step1Props {
  closeTask: Function;
  setStep: Function;
  handlerCloseModalTask: Function;
  responseStep1: any;
}

const Step1 = ({ closeTask, setStep, handlerCloseModalTask, responseStep1 }: Step1Props) => {
  const task: Task | any = useContext(TaskContext);
  const { data: taskResponses, reexecute: getTaskResponses } = useGetTaskResponsesByTask({
    variables: { findResponsesByTask: { taskId: task._id } },
    pause: true
  });

  const { execute: createResponseTask } = useCreateResponseTask();

  useEffect(() => {
    getTaskResponses({ requestPolicy: 'network-only' });
  }, [])

  const onChangeOption = (option: OptionsQuestionBasic) => {
    if(option.id === 2) {
      handlerCloseModalTask(false);
      return;
    } 

    if (task) {
      createResponseTask({
        key: option.id.toString(),
        label: option.title,
        step: 1,
        metadata: { optionId: option.id.toString() },
        task: task._id,
        state: TaskState.Approved,
        _id: responseStep1?._id,
      });
      setStep(2);
    }
  };

  return (
    <section>
      {task?.state === TaskState.Approved &&
        <SectionSuccessTask
          title="You've completed this task."
          button={{ title: "Back to dashboard", onClick: closeTask }}
        />
      }
      <h2 className="h3 mt-20">
        We need to confirm you have funds to cover closing costs, interest, and
        a down payment
      </h2>
      <div className="mt-30">
        <QuestionBasic
          type="buttons"
          question={
            <h3 className="h2">
              You’ll need to show account balances totaling {formatterCurrency(task?.metadata.jungoLimitBalance)} from any of:
            </h3>
          }
          text={null}
          listItems={[
            {
              id: 1,
              subTitle: 'Bank accounts:',
              text: 'You can use business or personal'
            },
            {
              id: 2,
              subTitle: 'Retirement/Pension accounts:',
              text: 'Only 50% of your balance will apply toward minimum liquidity'
            },
            {
              id: 3,
              subTitle: 'Cash-equivalent brokerage accounts',
              text: ''
            },
            {
              id: 4,
              subTitle: 'Other brokerage accounts:',
              text: 'Only 50% of your balance will apply toward minimum liquidity'
            }
          ]}
          options={[
            {
              id: 1,
              title: 'I’m ready to go!',
              styleHover: !canEditTaskInfo(task) ? 'option-hover-green' : 'option-hover-blue',
              disabled: !canEditTaskInfo(task),
              customClass: !canEditTaskInfo(task) ? 'option-active-APPROVED' : '',
              onClick: onChangeOption,
            },
            {
              id: 2,
              title: 'I’ll do this later',
              disabled: !canEditTaskInfo(task),
              styleHover: !canEditTaskInfo(task) ? '' : 'option-hover-blue',
              onClick: onChangeOption
            }
          ]}
        />
      </div>
    </section>
  );
};

export default Step1;
